export const HTMLCanvasElement = Object;
